<script setup lang="ts"></script>

<template>
  <span class="loading-dot"></span>
</template>

<style>
  @keyframes dotty {
    0% {
      content: '';
    }
    25% {
      content: '.';
    }
    50% {
      content: '..';
    }
    75% {
      content: '...';
    }
    100% {
      content: '';
    }
  }
  .loading-dot {
    width: 0;
    overflow-x: visible;
  }
  .loading-dot:after {
    content: '';
    animation: dotty steps(1, end) 1s infinite;
    display: inline-block;
    width: 0;
    overflow-x: visible;
  }
</style>
